import React from 'react';
import { getLandingPageUrl } from 'modules/landing-pages/utils/getLandingPageUrl';
import { useAccount } from 'modules/taboola-common-frontend-modules/account-configurations';
import LinkCellRenderer from './LinkCellRenderer';

// TODO: consider using an existing renderer/editor
const LandingPageSlugCellRenderer = ({ value, ...rest }) => {
    const { id } = useAccount();
    const {
        data: { status },
    } = rest;
    const text = getLandingPageUrl({ accountId: id, slug: value, status });

    return <LinkCellRenderer value={`${text}?timestamp=${Date.now()}`} text={text} {...rest} />;
};

export default LandingPageSlugCellRenderer;
